import { useMemo } from 'react';

import { Button } from 'antd';
import { formatUnits } from 'ethers';
import { useTranslation } from 'react-i18next';
import {
    useNavigate,
    useSearchParams,
} from 'react-router-dom';

import { tokenArr } from '@/collocate';
import LpProportion from '@/components/LpProportion';
import PresentData from '@/components/PresentData';
import ReturnCom from '@/components/ReturnCom';
import useFFRTokenLP from '@/hooks/useFFRTokenLP';
import useLpBalanceOf from '@/hooks/useLpBalanceOf';
import useLpContract from '@/hooks/useLpContract';
import useLpTotalSupply from '@/hooks/useLpTotalSupply';
import useReserve from '@/hooks/useReserve';
import {
    divideDecimal,
    formatTo6Decimals,
    multiplyDecimal,
} from '@/utils';

const MyLp = () => {
    const { t } = useTranslation()
    const router = useNavigate();
    const [searchParams] = useSearchParams();
    const lpAddress = searchParams.get('lpAddress') || '';
    // LP 合约实例
    const lpContract = useLpContract(lpAddress);
    // 获取我的 LP 余额s
    const { balanceLp, balanceLpLod } = useLpBalanceOf(lpContract);
    // 获取lp的总量
    const { totalSupply, totalSupplyLod } = useLpTotalSupply(lpContract);
    const tokenA = useMemo(() => {
        return tokenArr[Number(searchParams.get('tokenA')) || 0];
    }, [searchParams]);
    const tokenB = useMemo(() => {
        return tokenArr[Number(searchParams.get('tokenB')) || 0];
    }, [searchParams]);
    // 获取 tokenA 和 tokenB 的储备量
    const { tokenAReserve, tokenBReserve, reserveLod } = useReserve(lpContract, tokenA.address, tokenB.address);
    // 判断是不是 FFR
    const isFFR = (tokenA.address === tokenArr[0].address && tokenB.address === tokenArr[1].address) || (tokenA.address === tokenArr[1].address && tokenB.address === tokenArr[0].address)
    // 获取Token FFR 里面的lp份额，注意，只在FFR中有 也就是 Number(searchParams.get('tokenA')) 为0 的时候才调用
    const { getFFrTokenLPLod, FFRLP } = useFFRTokenLP(isFFR);
    const myLpInfo = useMemo(() => {
        if (!balanceLp || !totalSupply) return {
            shareBf: '0',
            token0Amount: '0',
            token1Amount: '0',
        }
        const share = divideDecimal(formatUnits(balanceLp), formatUnits(totalSupply))
        const shareBf = multiplyDecimal(share, 100);
        const token0Amount = multiplyDecimal(formatUnits(tokenAReserve), share);
        const token1Amount = multiplyDecimal(formatUnits(tokenBReserve), share);
        return {
            shareBf,
            token0Amount,
            token1Amount,
        }
    }, [tokenAReserve, tokenBReserve, totalSupply, balanceLp]);
    // 分红比例
    const dividendRatio = useMemo(() => {
        if (!FFRLP || !balanceLp) return '0';
        return multiplyDecimal(divideDecimal(formatUnits(balanceLp), formatUnits(FFRLP)), 100);
    }, [FFRLP, balanceLp]);
    console.log(dividendRatio);

    return (
        <div className='px-4 md:pt-10 md:max-w-xl md:mx-auto'>
            <div className='py-2.5 mb-7.5 md:hidden'> <ReturnCom title={'LP'} /></div>
            <LpProportion tokenA={tokenA} tokenB={tokenB} myLpInfo={myLpInfo} balanceLp={balanceLp} balanceLpLod={balanceLpLod} loading={totalSupplyLod || reserveLod || balanceLpLod} >
                {isFFR && <div className='flex items-center justify-between mb-2.5'>
                    <div>{t('myLp.dividendRatio')}:</div>
                    <PresentData text='%' value={formatTo6Decimals(dividendRatio as string)} loading={getFFrTokenLPLod} />
                </div>}
            </LpProportion>
            <div className='flex items-center justify-between'>
                <Button onClick={() => router(`/lpInfo?lpAddress=${lpAddress}&tokenA=${searchParams.get('tokenA')}&tokenB=${searchParams.get('tokenB')}`)} className='w-full rounded-5 mt-5 mr-5.5 bg-ffb border-ffb'>
                    {t('myLp.remove')}
                </Button>
                <Button onClick={() => router('/mobility')} className='w-full rounded-5 mt-5'>
                    {t('myLp.add')}
                </Button>
            </div>
        </div >
    )
}

export default MyLp